exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-danger {\r\n  font-size: small;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/send-values-widget/auth/auth.component.css
// module id = ../../../../../src/app/widget/send-values-widget/auth/auth.component.css
// module chunks = 5